module.exports = __webpack_public_path__ + "img/book_01.b8023fe1.jpg";